import React from 'react';
import { AlertTriangle, Check, Loader2 } from 'lucide-react';

const tijdstip = (d) =>
  d ? d.toLocaleTimeString('nl-BE', { hour: '2-digit', minute: '2-digit' }) : '';

/**
 * Statusregel bij automatisch opslaan.
 *
 * Zonder zichtbaar bewijs voelt automatisch opslaan onbetrouwbaar: de eigenaar
 * typt iets en weet niet of het ergens aankwam. Daarom altijd tonen wat er
 * gebeurde, met het tijdstip erbij.
 */
export function AutosaveStatus({ status, opgeslagenOp, foutmelding, onOpnieuw }) {
  if (status === 'fout') {
    return (
      <div className="flex items-center gap-2 text-sm text-red-600"
           role="status" data-testid="autosave-status">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span>
          Niet opgeslagen{foutmelding ? ` — ${foutmelding}` : ''}
        </span>
        <button type="button" onClick={onOpnieuw}
                className="underline font-medium hover:text-red-700"
                data-testid="autosave-retry-btn">
          Opnieuw proberen
        </button>
      </div>
    );
  }

  if (status === 'wacht' || status === 'bezig') {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-500"
           role="status" data-testid="autosave-status">
        <Loader2 className="w-4 h-4 animate-spin" />
        <span>Opslaan…</span>
      </div>
    );
  }

  if (status === 'opgeslagen') {
    return (
      <div className="flex items-center gap-2 text-sm text-emerald-600"
           role="status" data-testid="autosave-status">
        <Check className="w-4 h-4" />
        <span>Opgeslagen om {tijdstip(opgeslagenOp)}</span>
      </div>
    );
  }

  return null;
}
